import {Box, Card, CardContent, Pagination, Stack, Typography} from '@mui/material';
import {SeedQuestion} from '@cp/model';
import AdminSeedQuestionListItem from './AdminSeedQuestionListItem';
import AdminSeedQuestionListEmpty from './AdminSeedQuestionListEmpty';

export interface AdminSeedQuestionListProps {
  seedQuestions: SeedQuestion[];
  currentPage: number;
  totalPages: number;
  startIndex: number;
  loading: boolean;
  moduleId: string;
  totalItems?: number;
  onSeedQuestionClick: (seedQuestion: SeedQuestion) => void;
  onPageChange: (page: number) => void;
}

export default function AdminSeedQuestionList({
  seedQuestions,
  currentPage,
  totalPages,
  startIndex: _startIndex,
  loading,
  moduleId: _moduleId,
  totalItems,
  onSeedQuestionClick,
  onPageChange,
}: AdminSeedQuestionListProps) {
  if (seedQuestions.length === 0 && !loading) {
    return <AdminSeedQuestionListEmpty />;
  }

  return (
    <Card>
      <CardContent>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            mb: 2,
            minHeight: seedQuestions.length === 0 ? '100px' : 'auto',
          }}
        >
          <Typography variant="h6" sx={{color: '#1B263B'}}>
            Seed Questions{' '}
            {totalItems !== undefined ? `${seedQuestions.length}/${totalItems}` : `(${seedQuestions.length})`}
          </Typography>
          <Pagination
            count={totalPages}
            page={currentPage}
            onChange={(_, page) => onPageChange(page)}
            color="primary"
          />
        </Box>

        <Stack spacing={2}>
          {seedQuestions.map((seedQuestion: SeedQuestion) => (
            <AdminSeedQuestionListItem
              key={seedQuestion.id}
              seedQuestion={seedQuestion}
              onClick={onSeedQuestionClick}
            />
          ))}
        </Stack>
      </CardContent>
    </Card>
  );
}
